import { IEmpresas } from "../interfaces/IEmpresas";
import api from "./Api";

class LancamentosExtratoService {
    async buscar(esteiraID: number, acc: string): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`v2/LancamentoExtrato/DisponivelRemocao/${esteiraID}/${acc}`);
        return result;
    }

    async remover(id: number): Promise<void> {
        await api.delete<IEmpresas>(`v2/LancamentoExtrato/${id}`);
    }
}


export default new LancamentosExtratoService();